import React, { useState, useRef, useEffect } from "react";
import { Card, Form } from "react-bootstrap";

export const ExpandingTextarea = (props: {text: any, setText: any, sendChat: any, placeholder: any, isDisabled: boolean}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        props.setText(event.target.value);
    };

    useEffect(() => {
        // Update the parent container's height based on the textarea's height
        if (textareaRef.current && containerRef.current) {
            containerRef.current.style.height = `${textareaRef.current.scrollHeight + 4}px`;
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [props.text]);

    return (
        <div ref={containerRef}>
            <Form.Group className="mb-3">
                <Form.Control 
                    ref={textareaRef}
                    className="assistant-text-area"
                    as="textarea" 
                    rows={1}
                    value={props.text}
                    onChange={handleInputChange}
                    onKeyDown={props.sendChat}
                    placeholder={props.placeholder}
                    disabled={props.isDisabled}
                />
            </Form.Group>
        </div>
    );
};
